export const BASE_URL = "/api";
// export const BASE_URL = "http://localhost:8082";

// WebSocket URL - 動態使用當前 host
// 內網: ws://192.168.1.35/ws/token
// 正式環境會自動升級為: wss://att.sunsoft.space/ws/token
const protocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
const host = window.location.host;
export const WS_URL = `${protocol}//${host}/ws/token`;

